<template>
    <div class="max-w-500 w-full h-full mx-auto pb-16" data-cy="section_search_page">
        <TopBarBack data-cy="btn_search_results_back" @onClickBack="onBack()" />
        <div class="px-4 pt-6 pb-2.5" data-cy="container_search_input">
            <InputSearch
                ref="input-search"
                data-cy="input_search_results"
                v-model:inputValue="searchKeyword"
                :isBlueIcon="true"
                :isTextOnly="true"
                :txtPlaceholder="lbl.home.search_placeholder"
                @onEnter="onSearchCampaign()"
                @onChange="onChangeSearch($event)" />
        </div>
        <div class="mt-2.5 px-4" data-cy="container_search_results_list">
            <CampaignList
                    ref="campaign-list"
                    data-cy="list_search_campaign"
                    v-if="listConfig != null && filterConfig != null"
                    :initListConfig="listConfig"
                    :initFilterConfig="filterConfig"
                    :isSearch="true"
            ></CampaignList>
        </div>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import InputSearch from '@/module/List/component/SearchInput/InputSearch.vue';
import CampaignList from '@/module/List/component/CampaignList/CampaignList.vue';
//service
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";

export default {
    name: 'Search',
    inject: ["SearchStore"],
    mixins: [AuthPageMixin, LocaleMixin],
    components: {
        TopBarBack,
        InputSearch,
        CampaignList,
    },
    data: function(){
        return{
            searchKeyword: null,
            listConfig: null,
            filterConfig: null,

            loadingStatus: {
                campaign: false,
            },
        }
    },
    created: async function() {
        console.log('state', this.SearchStore.state.keyword);
        this.searchKeyword = this.SearchStore.state.keyword;

        this.setScrollLoadMore();
        this.initialConfig();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        initialConfig: function() {
            var configStr = ConfigManager.getCampaignListHome();
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                .setTop(25)
                .create();
            this.listConfig = listConfig;

            var filterConfig = new CampaignListFilterConfigBuilder();
            if (this.searchKeyword) {
                filterConfig.setSearch(this.searchKeyword);
            }
            this.filterConfig = filterConfig.create();
        },

        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        loadMore: function() {
            this.$refs['campaign-list'].loadMore();
        },
        onSearchCampaign: function() {
            this.SearchStore.methods.onSearch(this.searchKeyword);

            this.initialConfig();
            this.$refs['campaign-list'].reinitList(this.listConfig, this.filterConfig);
            //this.$refs['input-search'].clearInput();
        },
        onChangeSearch: function(data){
            this.searchKeyword = data;
            this.SearchStore.methods.onSearch(data);

            if(!data){
                this.initialConfig();
                this.$refs['campaign-list'].reinitList(this.listConfig, this.filterConfig);
            }
        },
        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.modal.loadingModal.hide();
                }
            }
        },
        sendError: function (error) {
            this.$emit('onError', error);
        },
        onBack: function(){
            this.$router.back();
        }
    },
}
</script>
